module.exports = __webpack_public_path__ + "img/hc_pro_five_3.b0e9af36.jpg";